import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { SigninService } from '@app/core';


@Injectable({
  providedIn: 'root',
})
export class LoggedOutGuard  {
  private _router = inject(Router);
  private _signinService = inject(SigninService);


  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (this._signinService.signedIn()) {
      return this._router.createUrlTree(['/']);
    }

    return true;
  }

}
